/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';

import { request } from '@mairistem/tools';
// import { FicheSidebarContainer } from '@mairistem/fiche';
import { App, Feature, Menu, render, SpeedDial } from '@mairistem/module';
import { Segment, Icon, Image, Tooltip } from '@mairistem/composants';

import { Context, AssistantContextProvider } from '@/components/Context';

import { ParameterPage } from './features';

// import RecenseFicheBarContainer from './components/Recense/Fiche/RecenseFicheBarContainer';
import RecenseFicheContainer from './components/Recense/Fiche/RecenseFicheContainer';
import { RecenseListe } from './components/Recense/Liste';
import { Dashboard } from './components/Dashboard';
import PeriodeTreeView from './components/Listes/ListePeriode/PeriodeTreeView';
import { useEntiteStore, useModalMajStore } from './zustand';
import {
  ModalToastContainer,
  NotesMiseAJourProvider,
} from './components/Common';
import { Assistant } from './components/Assistant';

import { initialize } from './sentry';
import DemandeHubee from './components/Hubee/Demande/DemandeHubee';
import ListeHubee from './components/Hubee/Liste/ListeHubee';

import hubee from './assets/images/hubee.png';

import './index.less';
import 'react-toastify/dist/ReactToastify.css';

initialize();

request.interceptors.request.use((config) => {
  if (process.env.NODE_ENV === 'production') {
    if (_.includes(window.location.href, '.jvsonline.fr')) {
      config.baseURL = 'https://360.jvsonline.fr';
    } else if (_.includes(window.location.href, '.qa.')) {
      config.baseURL = 'https://360.qa.jvs-mairistem.dev';
    } else if (_.includes(window.location.href, '.pp.')) {
      config.baseURL = 'https://360.pp.jvs-mairistem.dev';
    } else {
      config.baseURL = 'https://360.jvs-mairistem.dev';
    }
  } else {
    config.headers['X-Database'] = process.env.X_DATABASE;
    config.headers['X-Login'] = 2;
  }

  return config;
});

// Temporaire
const EntiteHandler = () => {
  const setRefresh = useEntiteStore((state) => state.setRefresh);

  React.useEffect(() => {
    setRefresh(true);
  }, [setRefresh]);

  return <div />;
};

const code = '360_RCO';
const showTooltips = !window.location.href.includes('360');

// Ne pas modifier ou supprimer
// Utile en mode production afin que le style se place au bonne endroit
if (process.env.NODE_ENV !== 'development') {
  const oldCreatePortal = ReactDOM.createPortal;

  // @ts-ignore
  ReactDOM.createPortal = (child, domNode) =>
    oldCreatePortal(
      child,
      domNode === document.body
        ? document.querySelector(`#${CSS.escape(code)}`) || domNode
        : domNode || document.querySelector(`#${CSS.escape(code)}`),
    );
}

render(
  <App
    group="administres"
    name="Recensement-Citoyen-Obligatoire"
    code={code}
    request={request}
    context={Context}
    additionalProductCodesUpdate={['HOL_TELE']}
  >
    <Menu
      name="Entités"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="building" />}
            message="Entités"
            position="right center"
          />
        ) : (
          <Icon name="building" />
        )
      }
      path="/entites"
    >
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <EntiteHandler />
          </>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu
      name="Accueil"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="home" />}
            message="Accueil"
            position="right center"
          />
        ) : (
          <Icon name="home" />
        )
      }
      path="/"
      exact
    >
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <NotesMiseAJourProvider />
            <Segment
              basic
              secondary
              style={{ margin: 0, height: '100%', padding: 0 }}
            >
              <Dashboard />
            </Segment>
          </>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu
      name="Paramètres"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="settings" />}
            message="Paramètres"
            position="right center"
          />
        ) : (
          <Icon name="settings" />
        )
      }
      path="/parametres"
    >
      <Feature path="/generaux">
        <Feature.Content>
          <>
            <NotesMiseAJourProvider />
            <ModalToastContainer />
            <ParameterPage generaux />
          </>
        </Feature.Content>
      </Feature>
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <ParameterPage />
          </>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu.Separator />
    <Menu
      name="Liste des recensés"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="users" />}
            message="Liste des recensés"
            position="right center"
          />
        ) : (
          <Icon name="users" />
        )
      }
      path="/recenses"
    >
      <Feature path="/assistant">
        <Feature.Content>
          <>
            <ModalToastContainer />
            <AssistantContextProvider>
              <Assistant />
            </AssistantContextProvider>
          </>
        </Feature.Content>
      </Feature>
      <Feature path="/:identifiant(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})">
        <Feature.Content>
          <>
            <ModalToastContainer />
            <RecenseFicheContainer />
          </>
        </Feature.Content>
      </Feature>
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <Segment basic secondary style={{ margin: 0, height: '100%' }}>
              <Segment
                raised
                style={{
                  height: '100%',
                  overflow: 'hidden',
                  borderRadius: '16px',
                }}
              >
                <RecenseListe />
              </Segment>
            </Segment>
          </>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu
      name="Liste des trimestres"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="calendar" />}
            message="Liste des trimestres"
            position="right center"
          />
        ) : (
          <Icon name="calendar" />
        )
      }
      path="/trimestres"
    >
      <Feature>
        <Feature.Content>
          <Segment basic secondary style={{ margin: 0, height: '100%' }}>
            <Segment
              raised
              style={{
                height: '100%',
                overflow: 'hidden',
                borderRadius: '16px',
              }}
            >
              <ModalToastContainer />
              <PeriodeTreeView />
            </Segment>
          </Segment>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu
      name="Liste des demandes HubEE"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={
              <Image
                src={hubee}
                style={{ borderRadius: '20px', height: 20, width: 20 }}
              />
            }
            message="Liste des demandes HubEE"
            position="right center"
          />
        ) : (
          <Image
            src={hubee}
            style={{ borderRadius: '20px', height: 20, width: 20 }}
          />
        )
      }
      path="/hubee"
    >
      <Feature>
        <Feature.Content>
          <Segment basic secondary style={{ margin: 0, height: '100%' }}>
            <Segment
              raised
              style={{
                height: '100%',
                overflow: 'hidden',
                borderRadius: '16px',
              }}
            >
              <ModalToastContainer />
              <ListeHubee />
            </Segment>
          </Segment>
        </Feature.Content>
      </Feature>
      <Feature path="/:identifiant(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})">
        <Feature.Content>
          <>
            <ModalToastContainer />
            <DemandeHubee />
          </>
        </Feature.Content>
      </Feature>
    </Menu>

    <Menu
      name="Notes de mises à jour"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={
              <Icon
                name="info circle"
                onClick={() => useModalMajStore.getState().setOpen(true)}
              />
            }
            message="Notes de mises à jour"
            position="right center"
          />
        ) : (
          <Icon
            name="info circle"
            onClick={() => useModalMajStore.getState().setOpen(true)}
          />
        )
      }
      path="/notes"
    >
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <NotesMiseAJourProvider openOnMount navigateBackOnClose />
          </>
        </Feature.Content>
      </Feature>
    </Menu>
    <SpeedDial>
      <SpeedDial.Button
        name="recense"
        title="Créer un recensé"
        icon="user"
        path="/recenses/assistant"
      />
    </SpeedDial>
  </App>,
);
